import React, { useId, useState } from 'react';
import { ChevronDown } from 'lucide-react';

// Collapsible section with a quiet chevron header ("⌄ Worked for 3m38s"):
// the row is muted text, the content hangs underneath. Uncontrolled unless
// `open`/`onOpenChange` are passed.
const Disclosure = ({
  label, meta, defaultOpen = false, open: openProp, onOpenChange, children, className,
}) => {
  const [openState, setOpenState] = useState(defaultOpen);
  const open = openProp ?? openState;
  const contentId = useId();
  const toggle = () => {
    const next = !open;
    if (openProp === undefined) setOpenState(next);
    onOpenChange?.(next);
  };
  return (
    <div className={['q-disclosure', className].filter(Boolean).join(' ')} data-open={open ? 'true' : 'false'}>
      <button
        type="button"
        className="q-disclosure__trigger"
        aria-expanded={open}
        aria-controls={contentId}
        onClick={toggle}
      >
        <ChevronDown aria-hidden className="q-disclosure__chevron" />
        <span>{label}</span>
        {meta != null && <span className="q-disclosure__meta">{meta}</span>}
      </button>
      {open && <div id={contentId} className="q-disclosure__content">{children}</div>}
    </div>
  );
};

export default Disclosure;
